<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>资源管理
        <span class="tipText">各位老师，上传资源后请耐心等待，若提示“资源加工失败”，再重新上传，期间请勿重复上传。</span>
      </p>
    </div>
    <div class="panel-content">
      <form
        id="searchSection"
        onSubmit="return false;"
      >
        <input
          type="text"
          placeholder="资源名称"
          class="s-input separate"
          v-model="queryInfo.title"
        >
        <input
          type="button"
          class="s-btn"
          value="搜索"
          @click="pageCallback(1)"
        >
        <div
          class="add-btn"
          id="addResource"
          @click="showAddWindow"
        >上传资源</div>
      </form>
      <ul
        id="resourceList"
        class="resource-list"
        v-if="tableData.length"
      >
        <li
          v-for="(item, index) in tableData"
          :key="index"
        >
          <div class="line-wrap">
            <div
              class="photo lookWare"
              index="0"
              @click="showViewWindow(item)"
            >
              <img
                src="/images/default.jpg"
                :onerror="$store.state.defaultImg"
              >
            </div>
            <div class="actionBtn">
              <a
                href="javascript:;"
                @click="editResource(item)"
                class="edit"
              >编辑</a>
              <a
                href="javascript:;"
                @click="delResource(item.id)"
                class="delete"
              >删除</a>
            </div>
            <div class="info">
              <div
                class="title"
                title="dog 2"
              >{{item.title}}</div>
              <div class="rl">
                <span class="res-type">媒体类型：{{ item.src.split('.')[item.src.split('.').length - 1] }}</span>
                <span class="size">{{ (item.size / 1024).toFixed(2) }}
                  KB</span>
                <span class="state">状态：处理完成</span>
                <span>相关课程：<template v-for="sub in JSON.parse(item.subject)">
                    {{ sub.content }}
                    &nbsp;&nbsp;
                  </template></span>
              </div>
            </div>
          </div>
          <div
            class="desc-wrap"
            title="345"
          >课件说明：{{ item.des }}</div>
        </li>
      </ul>
      <div
        class="noitems"
        v-else
      >没有数据</div>
      <!-- 分页 -->
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
    </div>

    <div
      class="form_overlay"
      id="ware_overlay"
      :style="classShowAddWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">新建/编辑资源</div>
        <a
          href="javascript:void(0)"
          class="overlay-close"
          @click="hideAddWindow"
        ><i class="iconfont"></i>

        </a>
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <span class="label"><i class="require">*</i>资源文件</span>
              <div class="item-box">
                <input
                  type="text"
                  disabled="disabled"
                  v-model="formInfo.src"
                >
                <span
                  class="button"
                  id="fileUpload"
                  @click="showUploadWindow"
                >添加文件</span>
              </div>
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>资源名称</span>
              <input
                type="text"
                autocomplete="off"
                v-model="formInfo.title"
                maxlength="25"
              >
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>相关课程</span>
              <div class="ipts-wrap">
                <ul
                  class="ipts-list"
                  id="courseList"
                >
                  <li
                    v-for="(item, index) in formResourceSubjectList"
                    :key="index"
                  >
                    <input
                      type="text"
                      v-model="item.content"
                      autocomplete="off"
                      maxlength="25"
                    >
                    <i
                      class="iconfont delCourse"
                      @click="delItem(index)"
                    ></i>
                  </li>
                </ul>
                <button
                  type="button"
                  class="addIpt"
                  id="addCourse"
                  @click="addSubject"
                >添加课程</button>
              </div>
            </div>
            <div class="item">
              <span class="label">资源说明</span>
              <textarea
                rows="5"
                class="form-control"
                placeholder=""
                v-model="formInfo.des"
              ></textarea>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="ware_close"
            @click="hideAddWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="ware_submit"
            @click="saveResource"
          >提交</a>
        </div>
      </div>
    </div>

    <div
      class="form_overlay"
      id="look_overlay"
      :style="classShowViewWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">查看资源</div>
        <a
          href="javascript:void(0)"
          class="overlay-close"
          @click="hideViewWindow"
        ><i class="iconfont"></i>

        </a>
        <div class="form_content">
          <div
            class="look-wrap"
            id="lookWrap"
          >
            <div
              class="video-wrap"
              v-if="viewInfo.src.split('.')[viewInfo.src.split('.').length - 1]=='mp4'"
            >
              <video
                style="background:#000;max-height:460px;max-width:100%;margin: 0 auto;display: block;"
                :src="$store.state.rootUrl+viewInfo.src.substr(1,viewInfo.src.length)"
                controls="controls"
              ></video>
            </div>
            <img
              v-if="viewInfo.src.split('.')[viewInfo.src.split('.').length - 1]=='png' || viewInfo.src.split('.')[viewInfo.src.split('.').length - 1]=='jpg'"
              :src="$store.state.rootUrl+viewInfo.src.substr(1,viewInfo.src.length)"
            />
          </div>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="look_close"
            @click="hideViewWindow"
          >取消</a>
        </div>
      </div>
    </div>
    <div
      id="file-upload-overlay"
      :style="classShowUploadWindow"
    >
      <div class="file-upload-bg"></div>
      <div class="file-upload">
        <div class="file-upload-type">允许上传的文件扩展名：jpg, png, mp4</div>
        <div
          class="file-upload-close"
          @click="hideUploadWindow"
        >×</div>
        <span
          class="file_uploadBtn"
          id="file_uploadBtn"
          style="display: block;"
        >
          选择文件<input
            type="file"
            id="file_fileInput"
            ref="docFile"
            accept=".jpg,.png,.mp4"
            style="display: block;"
            @change="fileChange"
          >
        </span>
        <div
          class="fileBox"
          id="file_uploadBox"
          style="display: block;"
        >
          <span
            class="pauseBtn"
            id="file_pauseBtn"
            style="display: none;"
          >暂停</span>
          <span
            class="goBtn"
            id="file_goBtn"
            style="display:none;"
          >继续</span>
          <div
            class="filename"
            id="file_filename"
            style="display: none;"
          ></div>
          <div
            class="pbar"
            style="showProgress ? 'display: block' : 'display: none'"
          >
            <div
              class="progress"
              id="file_progress"
              :style="'width: ' + Math.ceil(progressValue * 4.2) + 'px;'"
            ></div>
            <div id="file_percent">{{progressValue }}%</div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'
export default {
  name: 'ExperimentResource',
  components: {
    Pagination
  },
  data() {
    return {
      classShowAddWindow: {},
      classShowUploadWindow: {},
      classShowViewWindow: {},
      tableData: [],
      tableDataCount: 0,
      queryInfo: {
        page: 1,
        size: 10,
        title: ''
      },
      formInfo: {
        title: '',
        src: '',
        subject: '',
        des: ''
      },
      formResourceSubjectList: [],
      showProgress: false,
      progressValue: 0,
      viewInfo: {
        src: ''
      }
    }
  },
  methods: {
    async xlsChange() {

    },

    // 学院分页
    pageCallback(data) {
      this.queryInfo.page = data
      this.queryResource()
    },

    // 打开专业添加/编辑弹窗
    showAddWindow() {
      this.classShowAddWindow = {
        visibility: 'visible'
      }
    },
    // 关闭专业添加/编辑弹窗
    hideAddWindow() {
      this.classShowAddWindow = {}
    },
    // 打开上传弹窗
    showUploadWindow() {
      this.classShowUploadWindow = {
        display: 'block'
      }
    },
    // 关闭上传弹窗
    hideUploadWindow() {
      this.classShowUploadWindow = {}
    },
    showViewWindow(item) {
      this.viewInfo.src = item.src
      this.classShowViewWindow = {
        visibility: 'visible'
      }
    },
    hideViewWindow() {
      this.classShowViewWindow = {}
    },

    async queryResource() {
      await this.$http.get('/experimentresource/', { params: this.queryInfo }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('查询课件失败！')
      })
    },
    async fileChange() {
      if (this.$store.state.max_file_size && this.$refs.docFile.files[0].size > this.$store.state.max_file_size) {
        alert('文件大小超过限制！')
        return false
      }
      this.showProgress = true
      const fileRealName = this.$refs.docFile.files[0].name
      const uploadUrl = '/info_files/' + fileRealName
      await this.$http.put(uploadUrl, this.$refs.docFile.files[0], {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (e) => {
          // console.dir(e)
          this.progressValue = Math.ceil(e.loaded / e.total * 100)
        }
      }).then((data) => {
        this.showProgress = false
        this.progressValue = 0
        this.hideUploadWindow()

        // 此处处理data
        this.formInfo.src = data
        this.formInfo.size = this.$refs.docFile.files[0].size
      }).catch(() => {
        this.showProgress = false
        this.progressValue = 0
        this.hideUploadWindow()
        this.$parent.showMsg('上传失败！')
      })
    },
    addSubject() {
      this.formResourceSubjectList.push({
        content: ''
      })
    },
    async saveResource() {
      if (this.formInfo.src === '') {
        this.$parent.showMsg('请上传资源文件')
        return
      }
      if (this.formInfo.title === '') {
        this.$parent.showMsg('请填写资源名称')
        return
      }
      if (this.formResourceSubjectList.length === 0) {
        this.$parent.showMsg('请添加课程')
        return
      }
      this.formInfo.subject = JSON.stringify(this.formResourceSubjectList)
      if (this.formInfo.id) {
        const url = '/experimentresource/' + this.formInfo.id + '/'
        await this.$http.put(url, this.formInfo).then((data) => {
          if (data.id) {
            this.hideAddWindow()
            this.queryResource()
          } else {
            this.$parent.showMsg('修改失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('修改失败！')
        })
      } else {
        await this.$http.post('/experimentresource/', this.formInfo).then((data) => {
          if (data.id) {
            this.hideAddWindow()
            this.queryResource()
          } else {
            this.$parent.showMsg('添加失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('添加失败！')
        })
      }
    },
    editResource(item) {
      this.formInfo = {
        id: item.id,
        title: item.title,
        src: item.src,
        size: item.size,
        des: item.des,
        subject: item.subject
      }
      this.showAddWindow()
      this.formResourceSubjectList = this.formInfo ? JSON.parse(this.formInfo.subject) : [{ content: '' }]
    },
    async delResource(id) {
      const url = '/experimentresource/' + id + '/'
      await this.$parent.showConfirm('确认删除此条数据吗?', () => {
        this.$http.put(url, {
          isdel: 1
        }).then((data) => {
          if (data.id) {
            this.$parent.showMsg('删除成功！')
            this.queryResource()
          } else {
            this.$parent.showMsg('删除失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('删除失败！')
        })
      })
    },
    delItem(index) {
      this.formResourceSubjectList.splice(index, 1)
    }

  },
  // 计算属性
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    }

  },
  mounted() {
    this.queryResource()
    window.scroll(0, 0)
  }
}
</script>

<style scoped>
</style>
<style scoped src="../../../assets/css/chunkUpload.css"></style>
<style scoped src="../../../assets/css/resources.css"></style>
